import { IS_DISCORD_ACTIVITY } from '@/globals';

export function isTwitchUrl(url: string): boolean {
    return url.includes('twitch.tv/') && !url.includes('clips.twitch.tv');
}

export function extractTwitchChannel(url: string): string | null {
    try {
        const parsed = new URL(url);
        const parts = parsed.pathname.split('/').filter(Boolean);
        return parts[0] || null;
    } catch {
        return null;
    }
}

export function getTwitchParentDomains(): string[] {
    if (IS_DISCORD_ACTIVITY) {
        return [
            window.location.hostname,
            'discord.com',
            'discordapp.com',
            'canary.discord.com',
            'ptb.discord.com',
            'discord.gg',
            'discordsays.com',
        ];
    }
    return [window.location.hostname];
}
